// this reducer stores the hunts
// the hunts are pulled from /api/v1/hunts/get_all_hunts?password=asf4fvadfv31das

import {createSlice} from '@reduxjs/toolkit';
import localHuntList from 'src/Data/HuntLocationsLocal.js';

const initialState = {
  hunts: localHuntList,
  huntsList: Object.values(localHuntList),
  currentHunt: null,
};

const huntsSlice = createSlice({
  name: 'hunts',
  initialState,
  reducers: {
    setHunts(state, {payload: hunts}) {
      state.hunts = hunts;
    },
    setHuntsList(state, {payload: huntsList}) {
      state.huntsList = huntsList;
    },
    setCurrentHunt(state, {payload: currentHunt}) {
      state.currentHunt = currentHunt;
    },
  },
});

export const {setHunts, setHuntsList, setCurrentHunt} = huntsSlice.actions;

export default huntsSlice.reducer;
